<template>
    <BaseAccordion :accordion-ids="['collaboration-sources']" class="w-full border border-border rounded-xl overflow-hidden">
        <template #trigger-collaboration-sources>
            <div class="flex items-center gap-3 text-left">
                <BaseAvatar size="sm" aria-hidden="true">
                    <i class="bi bi-link-45deg text-lg" aria-hidden="true"></i>
                </BaseAvatar>
                <span>
                    <span class="block nadia-chat-bold">{{ t("chat.collaborationSources.title") }}</span>
                    <span class="block body-small text-ink-muted"> {{ t("chat.collaborationSources.sourcesUsed", { count: citations.length }, citations.length) }} </span>
                </span>
            </div>
        </template>
        <template #content-collaboration-sources>
            <ul class="border-t border-border px-4 py-2">
                <li v-for="citation in citations" :key="citation.url" class="border-b border-border last:border-b-0">
                    <a :href="citation.url" target="_blank" rel="noopener noreferrer" class="flex items-center justify-between gap-4 py-3 text-ink hover:underline">
                        <span class="min-w-0 text-left">
                            <span class="block capitalize body-small-semibold text-ink-muted">{{ citation.source_type }}</span>
                            <span class="block truncate">{{ citation.title }}</span>
                            <span class="mt-1 block body-small text-ink-muted line-clamp-2">{{ citation.detail }}</span>
                        </span>
                        <i class="bi bi-box-arrow-up-right shrink-0" aria-hidden="true"></i>
                    </a>
                </li>
            </ul>
        </template>
    </BaseAccordion>
</template>

<script setup lang="ts">
import BaseAccordion from "~vue/components/BaseAccordion.vue";
import BaseAvatar from "~vue/components/BaseAvatar.vue";
import type { CollaborationCitation } from "~vue/types/chat";
import { useI18n } from "vue-i18n";

type Props = {
    citations: CollaborationCitation[];
};

defineProps<Props>();
const { t } = useI18n();
</script>
